import { ChevronLeft, ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

// Shows at most five page numbers, sliding the window around the current page.
export default function Pagination({ page, pageCount, onChange, testId }) {
  if (pageCount <= 1) return null;
  const start = Math.max(1, Math.min(page - 2, pageCount - 4));
  const pages = Array.from({ length: Math.min(5, pageCount) }, (_, i) => start + i);
  const btn = "h-9 min-w-[2.25rem] px-2 rounded-lg border text-sm transition-colors disabled:opacity-40";
  return (
    <div className="flex items-center gap-1.5" data-testid={testId}>
      <button aria-label="Previous page" className={cn(btn, "border-border hover:bg-secondary")} disabled={page === 1} onClick={() => onChange(page - 1)}>
        <ChevronLeft className="h-4 w-4 mx-auto" />
      </button>
      {pages.map((p) => (
        <button
          key={p}
          onClick={() => onChange(p)}
          aria-current={p === page ? "page" : undefined}
          className={cn(btn, p === page ? "bg-primary border-primary text-primary-foreground" : "border-transparent hover:bg-secondary")}
        >
          {p}
        </button>
      ))}
      <button aria-label="Next page" className={cn(btn, "border-border hover:bg-secondary")} disabled={page === pageCount} onClick={() => onChange(page + 1)}>
        <ChevronRight className="h-4 w-4 mx-auto" />
      </button>
    </div>
  );
}
